export default "__VITE_ASSET__CklDLUwt__"